import { Checkbox, Form, Input, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setAnalysisData, setAnalysisProcessStatus, setIsSendToAnalysisOpen } from 'store/slices/aiFunctionsDataSlice';
import classes from './SendModal.module.scss';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';
import UploadingComponent from 'components/UploadingComponent/UploadingComponent';
import api from 'api';


type SendModalProps = {
  open: boolean;
};

const SendModal = ({ open }: SendModalProps) => {
  const [isFileSending, setIsFileSending] = React.useState(false);
  const [form] = Form.useForm();

  const { messageApi } = useAppSelector((store) => store.windowState);
  const { selectedDocument } = useAppSelector((store) => store.documents);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onCancelClick = () => {
    dispatch(setIsSendToAnalysisOpen(false));
  }

  const sendToAnalysis = async () => {
    if (!form.getFieldValue('agreement')) {
      form.setFields([{
        name: 'agreement',
        errors: [t('Documents.modals.sendToAnalysis.giveConsent')],
      }]);
      return;
    }
    setIsFileSending(true);

    try {
      await api.sendToAnalysis({document_id: selectedDocument!.id, user_input: form.getFieldValue('requirements')});    
      dispatch(setAnalysisData({ status: 'in_progress' }));
      dispatch(setAnalysisProcessStatus('analysising'));
      dispatch(setIsSendToAnalysisOpen(false));
      // setTimeout(() => {
      //   dispatch(setAnalysisData({ status: 'in_progress' }));
      //   dispatch(setAnalysisProcessStatus('analysising'));
      //   dispatch(setIsSendToAnalysisOpen(false));
      //   setIsFileSending(false);
      // }, 2000);
      // setTimeout(() => {
      //   dispatch(setAnalysisProcessStatus('analizing'));
      // }, 4000);
      // setTimeout(() => {
      //   dispatch(setAnalysisProcessStatus('generating'));
      // }, 6000);
      // setTimeout(() => {
      //   dispatch(setAnalysisProcessStatus('encrypt'));
      // }, 10000);
      // setTimeout(() => {
      //   dispatch(setAnalysisProcessStatus('storage_upload'));
      // }, 14000);
      // setTimeout(() => {
      //   dispatch(setAnalysisProcessStatus('downloading_report'));
      // }, 18000);
    } catch {
      messageApi?.error(t('Documents.modals.sendToAnalysis.errorSending'))
    } finally {
      setIsFileSending(false);
    }
  }

  return (
    <Modal
      title={t('Documents.modals.sendToAnalysis.title')}
      okText={t('Documents.modals.sendToAnalysis.send')}
      width={450}
      style={{ top: 200 }}
      open={open}
      onCancel={onCancelClick}
      onOk={form.submit}
      confirmLoading={isFileSending}
      className={cn(
        classes.sendModal,
        getTheme(),
      )}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{ loading: isFileSending }}
    >
      <Form
        form={form}
        layout='vertical'
        onFinish={sendToAnalysis}
      >
        <Form.Item
          name={'requirements'}
          label={t('Documents.modals.sendToAnalysis.additionalInfo')}
          rules={[
            { min: 10, message: t('Documents.modals.sendToAnalysis.tooShotrAddInfo', { number: 10 }) }
          ]}
        >
          <Input.TextArea
            autoSize={{minRows: 4, maxRows: 8}}
            placeholder={t('Documents.modals.sendToAnalysis.placeholder')}
          />
        </Form.Item>
        <Form.Item
          name={'agreement'}
          valuePropName='checked'
          rules={[
            { required: true, message: t('Documents.modals.sendToAnalysis.giveConsent') },
          ]}
        >
          <Checkbox>
            {t('Documents.modals.sendToAnalysis.toAgree')}
          </Checkbox>
        </Form.Item>
      </Form>

      {isFileSending && <UploadingComponent />}
    </Modal>
  );
}

export default SendModal;
